import React from 'react';
import './FunctionCard.css';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext'; // Importér LanguageContext

interface FunctionCardProps {
    title: string;
    description: string;
    eventId: number;
    functionId: number;
}



const FunctionCard: React.FC<FunctionCardProps> = ({ title, description, eventId, functionId }) => {
    const navigate = useNavigate();
    const { language } = useLanguage(); // Brug sprog fra LanguageContext

    const handleButtonClick = () => {
        // Naviger til den ønskede URL
        navigate(`/EventPage/${eventId}/Function/${functionId}`);
    };

    return (
        <div className="group-card">
            <button className="group-card-button" onClick={handleButtonClick}>{language === 'da' ? 'Vælg vagter' : 'Choose shifts'}</button>
            <div className="group-card-header">
                <h3>{title}</h3>
            </div>
            <div className="group-card-content">
                <p>{description || 'Ingen beskrivelse tilgængelig.'}</p>
            </div>
        </div>

    );
};

export default FunctionCard;
